import React, {
  type FC,
  type SyntheticEvent,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { Image } from 'wix-ui-tpa/cssVars';
import ccIconURI from '@assets/icons/creditCard.svg?url';
import { Skeleton } from '@components/Skeleton';
import { Experiment } from '@constants';
import { st, classes } from './PaymentMethodIcon.st.css';

type Props = {
  url: string;
  altText?: string;
  isLoading?: boolean;
};

export const PaymentMethodIcon: FC<Props> = ({
  url,
  altText = '',
  isLoading,
}) => {
  const { experiments } = useExperiments();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleError = useCallback((e: SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = ccIconURI;
  }, []);

  const handleLoad = useCallback(() => {
    setIsImageLoaded(true);
  }, []);

  useEffect(() => {
    if (isLoading) {
      setIsImageLoaded(false);
    }
  }, [isLoading]);

  if (!experiments.enabled(Experiment.UseSitePaymentMethodTypes)) {
    return (
      <Image
        src={url}
        alt={altText}
        width={45}
        height={28}
        errorMessage=""
        onError={handleError}
      />
    );
  }

  return (
    <>
      {!isImageLoaded && <Skeleton />}
      {!isLoading && (
        <Image
          src={url}
          alt={altText}
          width={45}
          height={28}
          className={st(classes.root, { hidden: !isImageLoaded })}
          errorMessage=""
          onError={handleError}
          onLoad={handleLoad}
        />
      )}
    </>
  );
};
